// Module
var code = "<uib-tabset active=\"vm.activeTab\"><uib-tab index=\"0\" heading=\"Letters\"><letters-tab visit=\"vm.visit\"></letters-tab></uib-tab><uib-tab index=\"1\" heading=\"Medication\"><medication-photo [visit]=\"vm.visit\"></medication-photo></uib-tab></uib-tabset>";
// Exports
var _module_exports =code;;
var path = 'app/views/visits/detail/sections/documents/documents.component.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;